import Marquee from "react-fast-marquee";
import { useI18n } from "../../i18n/LanguageProvider";
import { Container } from "../Container";

const PARTNERS = [
  { name: "Stripe", src: "/partners/stripe.png", h: "h-8 md:h-9" },
  { name: "Apple Pay", src: "/partners/applepay.png", h: "h-8 md:h-9" },
  { name: "Google Pay", src: "/partners/googlepay.png", h: "h-6 md:h-7" },
  { name: "Link", src: "/partners/link.png", h: "h-6 md:h-7" },
  { name: "Mastercard", src: "/partners/mastercard.png", h: "h-8 md:h-9" },
  { name: "Visa", src: "/partners/visa.png", h: "h-6 md:h-7" },
];

export function PaymentPartners() {
  const { t } = useI18n();
  const items = [...PARTNERS, ...PARTNERS, ...PARTNERS];
  return (
    <section className="py-16 md:py-24" aria-label={t("partners.label")}>
      <Container>
        <p className="mb-12 text-center text-xs font-medium uppercase tracking-[0.22em] text-black/40">
          {t("partners.label")}
        </p>
        <Marquee speed={32} gradient gradientColor="#ffffff" gradientWidth={160} pauseOnHover autoFill={false}>
          {items.map((p, i) => (
            <div key={i} className="mx-10 flex items-center md:mx-14">
              <img
                src={p.src}
                alt={p.name}
                loading="lazy"
                draggable="false"
                className={`${p.h} w-auto select-none object-contain opacity-60 grayscale transition-[opacity,filter] duration-300 hover:opacity-100 hover:grayscale-0`}
              />
            </div>
          ))}
        </Marquee>
      </Container>
    </section>
  );
}
